// extracted by mini-css-extract-plugin
module.exports = {"alertDiv":"AlertMessageSent_alertDiv__1X-uW","fadeIn":"AlertMessageSent_fadeIn__1T-Zk","fade":"AlertMessageSent_fade__39x3T"};